'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (link) {
  var removeQueryParams = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  if (removeQueryParams) {
    var indexOfQueryParams = link.lastIndexOf('?');

    if (indexOfQueryParams >= 0) {
      link = link.substr(0, indexOfQueryParams);
    }
  }

  link = link.replace(/^https?:\/\//i, '').replace(/\/#?$/, '');
  return link;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/cleanUp.js
 ** module id = 61
 ** module chunks = 0
 **/